import { IUserInfoFormFields } from '../UserInfoFormFields.types';

type IUserInfoFormFieldsKey = keyof IUserInfoFormFields;

const RequiredFieldForTenants: {
  label: string;
  value: IUserInfoFormFieldsKey;
}[] = [
  { label: 'form:first_name', value: 'first_name' },
  { label: 'form:lastName', value: 'last_name' },
  { label: 'form:email', value: 'email' },
  { label: 'form:phoneNumber', value: 'phone_no' },
  { label: 'form:dateOfBirth', value: 'birthday' },
  { label: 'form:cityOfBirth', value: 'place_of_birth' },
  { label: 'form:cityOfResidence', value: 'city' },
  { label: 'form:country', value: 'country' },
  { label: 'form:province', value: 'residence_province' },
  { label: 'form:residenceAddress', value: 'residence_address' },
  { label: 'form:postalCode', value: 'residence_postcode' },
  { label: 'form:identityDocument', value: 'id_document_number' },
  { label: 'form:documentExpiryDate', value: 'id_document_expiry_date' },
  { label: 'form:taxCode', value: 'tax_code' },
];

export const filterMissingInfoForPersonalInformation = ({
  values,
}: {
  values: IUserInfoFormFields;
}) => {
  const emptyFields = RequiredFieldForTenants.filter(
    field => !values[field.value],
  ).map(field => field.label);

  const label = 'translation:personalInformation';

  return {
    label,
    fields: emptyFields,
  };
};
